import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface UsageType {
    type: UsageMessage;
    message?: string;
    details?: any;
}

@Injectable()
export class UsageService extends Subject<UsageType> {}

export enum UsageMessage {
    APP_INIT,
    APP_LOGIN,
    GLOBALNAV_SELECT,
    VIEW_CREATED,
    NAVIGATION_ROUTE
}
